'use strict';
function _typeof(o) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (o) {
        return typeof o;
    } : function (o) {
        return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
    }, _typeof(o);
}
function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError('Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ('string' == typeof r)
            return _arrayLikeToArray(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return 'Object' === t && r.constructor && (t = r.constructor.name), 'Map' === t || 'Set' === t ? Array.from(r) : 'Arguments' === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for (var e = 0, n = Array(a); e < a; e++)
        n[e] = r[e];
    return n;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : 'undefined' != typeof Symbol && r[Symbol.iterator] || r['@@iterator'];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t)
                    return;
                f = !1;
            } else
                for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally {
            try {
                if (!f && null != t['return'] && (u = t['return'](), Object(u) !== u))
                    return;
            } finally {
                if (o)
                    throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(r) {
    if (Array.isArray(r))
        return r;
}
function _classCallCheck(a, n) {
    if (!(a instanceof n))
        throw new TypeError('Cannot call a class as a function');
}
function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, 'value' in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, 'prototype', { writable: !1 }), e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, 'string');
    return 'symbol' == _typeof(i) ? i : i + '';
}
function _toPrimitive(t, r) {
    if ('object' != _typeof(t) || !t)
        return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != _typeof(i))
            return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return ('string' === r ? String : Number)(t);
}
import utils from '../utils.js';
import parseHeaders from '../helpers/parseHeaders.js';
var $internals = Symbol('internals');
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) {
        return value;
    }
    return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
    var tokens = Object.create(null);
    var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    var match;
    while (match = tokensRE.exec(str)) {
        tokens[match[1]] = match[2];
    }
    return tokens;
}
var isValidHeaderName = function isValidHeaderName(str) {
    return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
};
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if (utils.isFunction(filter)) {
        return filter.call(this, value, header);
    }
    if (isHeaderNameFilter) {
        value = header;
    }
    if (!utils.isString(value))
        return;
    if (utils.isString(filter)) {
        return value.indexOf(filter) !== -1;
    }
    if (utils.isRegExp(filter)) {
        return filter.test(value);
    }
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function (w, _char, str) {
        return _char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    var accessorName = utils.toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach(function (methodName) {
        Object.defineProperty(obj, methodName + accessorName, {
            value: function value(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
var AxiosHeaders = function () {
    function AxiosHeaders(headers) {
        _classCallCheck(this, AxiosHeaders);
        headers && this.set(headers);
    }
    return _createClass(AxiosHeaders, [
        {
            key: 'set',
            value: function set(header, valueOrRewrite, rewrite) {
                var self = this;
                function setHeader(_value, _header, _rewrite) {
                    var lHeader = normalizeHeader(_header);
                    if (!lHeader) {
                        throw new Error('header name must be a non-empty string');
                    }
                    var key = utils.findKey(self, lHeader);
                    if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) {
                        self[key || _header] = normalizeValue(_value);
                    }
                }
                var setHeaders = function setHeaders(headers, _rewrite) {
                    return utils.forEach(headers, function (_value, _header) {
                        return setHeader(_value, _header, _rewrite);
                    });
                };
                if (utils.isPlainObject(header) || header instanceof this.constructor) {
                    setHeaders(header, valueOrRewrite);
                } else if (utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
                    setHeaders(parseHeaders(header), valueOrRewrite);
                } else {
                    header != null && setHeader(valueOrRewrite, header, rewrite);
                }
                return this;
            }
        },
        {
            key: 'get',
            value: function get(header, parser) {
                header = normalizeHeader(header);
                if (header) {
                    var key = utils.findKey(this, header);
                    if (key) {
                        var value = this[key];
                        if (!parser) {
                            return value;
                        }
                        if (parser === true) {
                            return parseTokens(value);
                        }
                        if (utils.isFunction(parser)) {
                            return parser.call(this, value, key);
                        }
                        if (utils.isRegExp(parser)) {
                            return parser.exec(value);
                        }
                        throw new TypeError('parser must be boolean|regexp|function');
                    }
                }
            }
        },
        {
            key: 'has',
            value: function has(header, matcher) {
                header = normalizeHeader(header);
                if (header) {
                    var key = utils.findKey(this, header);
                    return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
                }
                return false;
            }
        },
        {
            key: 'delete',
            value: function _delete(header, matcher) {
                var self = this;
                var deleted = false;
                function deleteHeader(_header) {
                    _header = normalizeHeader(_header);
                    if (_header) {
                        var key = utils.findKey(self, _header);
                        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                            delete self[key];
                            deleted = true;
                        }
                    }
                }
                if (utils.isArray(header)) {
                    header.forEach(deleteHeader);
                } else {
                    deleteHeader(header);
                }
                return deleted;
            }
        },
        {
            key: 'clear',
            value: function clear(matcher) {
                var keys = Object.keys(this);
                var i = keys.length;
                var deleted = false;
                while (i--) {
                    var key = keys[i];
                    if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                        delete this[key];
                        deleted = true;
                    }
                }
                return deleted;
            }
        },
        {
            key: 'normalize',
            value: function normalize(format) {
                var self = this;
                var headers = {};
                utils.forEach(this, function (value, header) {
                    var key = utils.findKey(headers, header);
                    if (key) {
                        self[key] = normalizeValue(value);
                        delete self[header];
                        return;
                    }
                    var normalized = format ? formatHeader(header) : String(header).trim();
                    if (normalized !== header) {
                        delete self[header];
                    }
                    self[normalized] = normalizeValue(value);
                    headers[normalized] = true;
                });
                return this;
            }
        },
        {
            key: 'concat',
            value: function concat() {
                var _this$constructor;
                for (var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++) {
                    targets[_key] = arguments[_key];
                }
                return (_this$constructor = this.constructor).concat.apply(_this$constructor, [this].concat(targets));
            }
        },
        {
            key: 'toJSON',
            value: function toJSON(asStrings) {
                var obj = Object.create(null);
                utils.forEach(this, function (value, header) {
                    value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
                });
                return obj;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return Object.entries(this.toJSON())[Symbol.iterator]();
            }
        },
        {
            key: 'toString',
            value: function toString() {
                return Object.entries(this.toJSON()).map(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2), header = _ref2[0], value = _ref2[1];
                    return header + ': ' + value;
                }).join('\n');
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return 'AxiosHeaders';
            }
        }
    ], [
        {
            key: 'from',
            value: function from(thing) {
                return thing instanceof this ? thing : new this(thing);
            }
        },
        {
            key: 'concat',
            value: function concat(first) {
                var computed = new this(first);
                for (var _len2 = arguments.length, targets = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                    targets[_key2 - 1] = arguments[_key2];
                }
                targets.forEach(function (target) {
                    return computed.set(target);
                });
                return computed;
            }
        },
        {
            key: 'accessor',
            value: function accessor(header) {
                var internals = this[$internals] = this[$internals] = { accessors: {} };
                var accessors = internals.accessors;
                var prototype = this.prototype;
                function defineAccessor(_header) {
                    var lHeader = normalizeHeader(_header);
                    if (!accessors[lHeader]) {
                        buildAccessors(prototype, _header);
                        accessors[lHeader] = true;
                    }
                }
                utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
                return this;
            }
        }
    ]);
}();
AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
utils.freezeMethods(AxiosHeaders.prototype);
utils.freezeMethods(AxiosHeaders);
export default AxiosHeaders;